<template>
    <v-layout>
      VERÖFFENTLICHUNGEN
    </v-layout>
</template>

<script>
//import Vue from 'vue'
export default {
  name: 'Veroeffentlichungen',
  components: {},
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    //Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>
